import '../../../stylesheets/dashboards/dashboards.css'
import '../../../stylesheets/dashboards/leaderboard.css'
import { useState, useEffect, useRef }                         from 'react'
import { usePublicAPI }                                        from '../../../hooks/external/proprietary/usePublicAPI.js';
import { assembleBarLayoutDTO, resolveStackedClassForColor,
         resolveChangeSignage                              }   from '../../../services/leaderboard/main/main.js';
import { formatNumber, formatNumberTwoDecimal,
         formatPercent, formatDollar }                         from '../../../utilities/formatNumber.js';

const MoversBarLayout = (props) => {

    const {orderedCompanyPriceData, cpdActiveFields, type} = props

    // **====== Hooks ======** //
    const { getCoLogo } = usePublicAPI();

    // ** Local Variables **
    const barLayoutDTO = assembleBarLayoutDTO(orderedCompanyPriceData, cpdActiveFields)

    return (
        <div className="leaderboard-bar-container">
            {orderedCompanyPriceData.map((cpd) => (
                <div key={cpd.id} className="leaderboard-bar-row">
                    <div className="logo-card-company-ticker">{cpd.ticker}</div>
                    <img
                        src={getCoLogo(cpd.ticker)}
                        alt={cpd.name}
                        className="logo-card-company-logo leaderboard-bar"
                    />
                    <div className={`leaderboard-bar-track ${barLayoutDTO.barGutter}`}>
                        <div
                            className={`leaderboard-bar-fill ${resolveStackedClassForColor(cpd[cpdActiveFields.heat], "all-cos-bar")}`}
                            style={barLayoutDTO.placements[cpd.id]}
                        >
                            <span className={`leaderboard-bar-value ${resolveStackedClassForColor(cpd[cpdActiveFields.heat], "all-cos-bar-value")}`}>
                                {/* symbol for change value displayed based on heat (+/-) and type ($/%) */}
                                {resolveChangeSignage(cpd[cpdActiveFields.change], cpd[cpdActiveFields.heat], type)}
                            </span>
                        </div>
                        <div className="leaderboard-tooltip">
                            <span className="leaderboard-cell-ticker"> {cpd.ticker}</span>
                            <span className="leaderboard-cell-name">{cpd.name}</span>
                            <span className="leaderboard-cell-price">${formatNumberTwoDecimal(cpd.priceCurrent)}</span> 
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}


export default MoversBarLayout;
